export const WORKSPACE_INDICATOR_TOAST_FIELD =
	'isWorkspaceIndicatorToastOpened';
